<template>
  <div>
    <div class="ts-flex ts-justify-between">
      <ts-button outline color="info" @click.prevent="addNew">
        {{ $t('add_new') }}
      </ts-button>

      <div>
        <Input
          v-model="search"
          suffix="ios-search"
          placeholder="Search|Title,Owner"
          style="width: auto"
          @on-change="fetchData"
        />
      </div>
    </div>
    <div class="ts-h-3"></div>
    <Table
      :columns="columns"
      :data="resources"
      :loading="loading"
      size="small"
      fixed-shadow="hide"
      max-height="700"
    >
      <template slot-scope="{ row }" slot="title">
        <a
          href="#"
          v-if="row.file_storage_path"
          @click.prevent="onViewFile(row)"
        >
          {{ row.title }}
          <i class="fas fa-paperclip"></i>
        </a>
        <span v-else>{{ row.title }}</span>
      </template>
      <template slot-scope="{ row }" slot="estimate">
        <div style="width: fit-content;" v-if="row.estimate_end_date">
          <Icon type="ios-calendar-outline ts-mr-1" />
          <span>{{ row.estimate_start_date }}</span>
          <Icon type="ios-calendar-outline ts-mr-1 ts-ml-2" />
          <span>{{ row.estimate_end_date }}</span>
        </div>
      </template>
      <template slot-scope="{ row }" slot="actual">
        <div style="width: fit-content;" v-if="row.actual_end_date">
          <Icon type="ios-calendar-outline ts-mr-1" />
          <span>{{ row.actual_start_date }}</span>
          <Icon type="ios-calendar-outline ts-mr-1 ts-ml-2" />
          <span>{{ row.actual_end_date }}</span>
        </div>
      </template>
      <template slot-scope="{ row }" slot="actions">
        <div
          class="ts-flex ts-space-x-2 ts-items-center"
          style="width: fit-content;"
        >
          <a
            href="#"
            class="text-primary ts-relative"
            @click.prevent="onShowReport(row)"
            v-tooltip="$t('task.report')"
          >
            <div
              v-if="row.reports_count"
              class="ts-absolute ts-right-0 ts-top-0 ts-mr-2 ts-h-2 ts-w-2 ts-bg-red-600 ts-rounded-full"
            ></div>
            <i class="fas fa-file-signature ts-text-base ts-mr-2"></i>
          </a>
          <a
            href="#"
            class="text-primary"
            @click.prevent="onEdit(row)"
            v-tooltip="$t('edit')"
          >
            <Icon type="ios-create" size="20" />
          </a>
          <a
            href="#"
            class="text-danger"
            v-tooltip="$t('delete')"
            @click="deleteRecord(row)"
            :disabled="row._deleting"
          >
            <i class="fas fa-circle-notch fa-spin" v-if="row._deleting"></i>
            <Icon type="ios-trash" size="20" v-else />
          </a>
        </div>
      </template>
    </Table>
    <iModalWrapper v-model="isCreateNew" :title="$t('create')">
      <CreateForm v-if="isCreateNew" @close="onCloseModal" />
    </iModalWrapper>
    <iModalWrapper v-model="isUpdate" :title="$t('update')">
      <EditForm :edit_data="edit_data" v-if="isUpdate" @close="onCloseModal" />
    </iModalWrapper>
    <iModalWrapper
      v-model="isShowReport"
      :title="$t('task.report')"
      width="50%"
    >
      <ReportOnSubTask
        :edit_data="edit_data"
        v-if="isShowReport"
        @close="onCloseModal"
      />
    </iModalWrapper>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { debounce } from 'lodash'
import CreateForm from './create-sub-task-form.vue'
import EditForm from './edit-sub-task-form.vue'
import ReportOnSubTask from './report-on-sub-task.vue'
import iModalWrapper from '../../components/i-modal-wrapper.vue'
export default {
  components: {
    CreateForm,
    EditForm,
    iModalWrapper,
    ReportOnSubTask
  },
  data() {
    return {
      resources: [],
      edit_data: [],
      loading: false,
      isCreateNew: false,
      isUpdate: false,
      isShowReport: false,
      search: ''
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('task.title'),
          slot: 'title',
          sortable: true,
          minWidth: 200,
          className: 'ts-font-robot ts-font-hanuman',
          fixed: 'left'
        },
        {
          title: this.$t('task.owner'),
          key: 'owner_name',
          sortable: true,
          width: 200,
          className: 'ts-font-robot',
          fixed: 'left'
        },
        {
          title: this.$t('task.status'),
          key: 'project_status',
          sortable: true,
          width: 120,
          className: 'ts-font-robot',
          fixed: 'left'
        },
        {
          title: this.$t('task.estimated'),
          slot: 'estimate',
          width: 200,
          className: 'ts-font-robot',
          fixed: 'left'
        },
        {
          title: this.$t('task.actual'),
          slot: 'actual',
          width: 200,
          className: 'ts-font-robot',
          fixed: 'left'
        },
        {
          title: this.$t('task.remark'),
          key: 'remark',
          minWidth: 120,
          className: 'ts-font-robot ts-font-hanuman',
          fixed: 'left'
        },
        {
          title: this.$t('actions'),
          slot: 'actions',
          fixed: 'right',
          align: 'left',
          className: 'ts-font-robot',
          width: 130
        }
      ]
    }
  },
  created() {
    this.fetchSubTask()
  },
  methods: {
    ...mapActions('projectMgt/subTaskProfile', ['fetch', 'destroy']),
    addNew() {
      this.isCreateNew = true
    },
    fetchSubTask() {
      if (this.resources.length == 0) {
        this.fetchData()
      }
    },
    fetchData: debounce(function() {
      this.loading = true
      const id = this.$route.params.id
      this.fetch({
        id,
        params: {
          search: this.search
        }
      })
        .then(response => {
          this.resources = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    }, 600),
    onCloseModal() {
      this.isCreateNew = false
      this.isUpdate = false
      this.fetchData()
    },
    deleteRecord(record) {
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        centered: true,
        onOk: () => {
          return this.destroy(record.id)
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    },
    onEdit(record) {
      this.isUpdate = true
      this.edit_data = record
    },
    onViewFile(record) {
      window.open(record.file_storage_path_read, '_blank')
    },
    onShowReport(row) {
      this.isShowReport = true
      this.edit_data = row
    }
  }
}
</script>
